import { render, staticRenderFns } from "./RecapSlider.vue?vue&type=template&id=18770fce&scoped=true&"
import script from "./RecapSlider.vue?vue&type=script&lang=js&"
export * from "./RecapSlider.vue?vue&type=script&lang=js&"
import style0 from "./RecapSlider.vue?vue&type=style&index=0&id=18770fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18770fce",
  null
  
)

export default component.exports